import { TrackingLevel } from "./enumerations";

const mappirize = (dsMap) => {
    Object.freeze(dsMap);

    if (DEBUG && window.Proxy) {
        return new Proxy(dsMap, {
            get: (target, name) => {
                if (target[name] === undefined) {
                    throw new Error(`Map has no member ${name}.`);
                }
                return target[name];
            }
        });
    }

    return dsMap;
}

export const CORPORATE_STRUCTURE_ENTITIES_MAP = mappirize({
    [TrackingLevel.PRODUCT]: 'Product',
    [TrackingLevel.GEO_AREA]: 'GeoArea',
    [TrackingLevel.CUSTOMER]: 'Customer',
    [TrackingLevel.TRACKING_LEVEL_1]: 'TrackingLevel1Item',
    [TrackingLevel.TRACKING_LEVEL_2]: 'TrackingLevel2Item',
    [TrackingLevel.TRACKING_LEVEL_3]: 'TrackingLevel3Item',
    [TrackingLevel.TRACKING_LEVEL_4]: 'TrackingLevel4Item',
    [TrackingLevel.COMPANY_LEGAL_ENTITY]: 'CompanyLegalEntity',
    [TrackingLevel.COMPANY_FUNCTION]: 'CompanyFunction'
});

export const CORPORATE_STRUCTURE_STORE_KEYS_MAP = mappirize({
    [TrackingLevel.PRODUCT]: 'products',
    [TrackingLevel.GEO_AREA]: 'geoAreas',
    [TrackingLevel.CUSTOMER]: 'customers',
    [TrackingLevel.TRACKING_LEVEL_1]: 'trackingLevel1Items',
    [TrackingLevel.TRACKING_LEVEL_2]: 'trackingLevel2Items',
    [TrackingLevel.TRACKING_LEVEL_3]: 'trackingLevel3Items',
    [TrackingLevel.TRACKING_LEVEL_4]: 'trackingLevel4Items',
    [TrackingLevel.COMPANY_LEGAL_ENTITY]: 'companyLegalEntities',
    [TrackingLevel.COMPANY_FUNCTION]: 'companyFunctions'
});


export const CORPORATE_STRUCTURE_LINK_PROPERTIES_MAP = mappirize({
    [TrackingLevel.PRODUCT]: 'ProductID',
    [TrackingLevel.GEO_AREA]: 'GeoAreaID',
    [TrackingLevel.CUSTOMER]: 'CustomerID',
    [TrackingLevel.TRACKING_LEVEL_1]: 'TrackingLevel1ItemID',
    [TrackingLevel.TRACKING_LEVEL_2]: 'TrackingLevel2ItemID',
    [TrackingLevel.TRACKING_LEVEL_3]: 'TrackingLevel3ItemID',
    [TrackingLevel.TRACKING_LEVEL_4]: 'TrackingLevel4ItemID',
    [TrackingLevel.COMPANY_LEGAL_ENTITY]: 'CompanyLegalEntityID',
    [TrackingLevel.COMPANY_FUNCTION]: 'CompanyFunctionID'
});

export const CORPORATE_STRUCTURE_FILTER_PROPERTIES_MAP = mappirize({
    [TrackingLevel.PRODUCT]: 'ProductIDs',
    [TrackingLevel.GEO_AREA]: 'GeoAreaIDs',
    [TrackingLevel.CUSTOMER]: 'CustomerIDs',
    [TrackingLevel.TRACKING_LEVEL_1]: 'TrackingLevel1ItemIDs',
    [TrackingLevel.TRACKING_LEVEL_2]: 'TrackingLevel2ItemIDs',
    [TrackingLevel.TRACKING_LEVEL_3]: 'TrackingLevel3ItemIDs',
    [TrackingLevel.TRACKING_LEVEL_4]: 'TrackingLevel4ItemIDs',
    [TrackingLevel.COMPANY_LEGAL_ENTITY]: 'CompanyLegalEntityIDs',
    [TrackingLevel.COMPANY_FUNCTION]: 'CompanyFunctionIDs'
});

export const CORPORATE_STRUCTURE_INDICATOR_COLLECT_PROPERTIES_MAP = mappirize({
    [TrackingLevel.PRODUCT]: 'CollectProduct',
    [TrackingLevel.GEO_AREA]: 'CollectGeoArea',
    [TrackingLevel.CUSTOMER]: 'CollectCustomer',
    [TrackingLevel.TRACKING_LEVEL_1]: 'CollectTrackingLevel1',
    [TrackingLevel.TRACKING_LEVEL_2]: 'CollectTrackingLevel2',
    [TrackingLevel.TRACKING_LEVEL_3]: 'CollectTrackingLevel3',
    [TrackingLevel.TRACKING_LEVEL_4]: 'CollectTrackingLevel4',
    [TrackingLevel.COMPANY_LEGAL_ENTITY]: 'CollectLegalUnit',
    [TrackingLevel.COMPANY_FUNCTION]: 'CollectFunction'
});

export const CORPORATE_STRUCTURE_DASHBOARD_FILTERING_ENABLEDNESS_PROPERTIES_MAP = mappirize({
    [TrackingLevel.PRODUCT]: 'ProductFilteringEnabled',
    [TrackingLevel.GEO_AREA]: 'GeoAreaFilteringEnabled',
    [TrackingLevel.CUSTOMER]: 'CustomerFilteringEnabled',
    [TrackingLevel.TRACKING_LEVEL_1]: 'TrackingLevel1FilteringEnabled',
    [TrackingLevel.TRACKING_LEVEL_2]: 'TrackingLevel2FilteringEnabled',
    [TrackingLevel.TRACKING_LEVEL_3]: 'TrackingLevel3FilteringEnabled',
    [TrackingLevel.TRACKING_LEVEL_4]: 'TrackingLevel4FilteringEnabled',
    [TrackingLevel.COMPANY_LEGAL_ENTITY]: 'CompanyLegalEntityFilteringEnabled',
    [TrackingLevel.COMPANY_FUNCTION]: 'CompanyFunctionFilteringEnabled'
});